import React, { Component } from 'react';
import { MASK_PROPS } from './Types';
import { classNames } from '@progress/kendo-react-common';
import { MaskType } from '../../Types';

class Mask extends Component<MASK_PROPS, {}> {
  /**
   * @inheritDocs
   */
  componentWillUnmount = () => {
    setTimeout(this.injectLoadingCompletedElement, 1);
  };

  /**
   * @inheritDoc
   */
  componentDidMount(): void {
    const div = document.getElementById('loadedData');
    if (div) {
      div.remove();
    }
    if (this.props.componentDidMount) {
      this.props.componentDidMount();
    }
  }

  /**
   * Accessibility needs
   * Added so screen reader could notify user that mask is removed and data loading is completed
   */
  injectLoadingCompletedElement = () => {
    const div = document.getElementById('loadedData');
    if (!div) {
      let divElement = document.createElement('div');
      divElement.id = 'loadedData';
      divElement.style.position = 'relative';
      divElement.innerHTML = this.props.endMaskMassage;
      divElement.setAttribute('role', 'alert');
      if (document.getElementById('root')) {
        document.getElementById('root').appendChild(divElement);
      }
    }
  };

  render() {
    const {
      className = 'tp-puzzle-mask',
      maskType,
      top,
      left,
      width,
      height,
      key,
      maskForModuleId,
      message
    } = this.props;

    const maskClass = classNames(
      `tp-mask ${className}`,
      {
        'tp-square-background': maskType === MaskType.LIGHT_SQUARE,
        'tp-mask-light-fill': maskType === MaskType.LIGHT_FILL,
        'tp-mask-splash': maskType === MaskType.SPLASH
      }
    );
    const loaderClass = classNames(
      {
        'tp-puzzle-loader-rings': maskType === MaskType.LIGHT_SQUARE || maskType === MaskType.LIGHT_FILL,
        'tp-splash-img': maskType === MaskType.SPLASH
      }
    );

    return (
      <div
        key={key}
        className={maskClass}
        style={{
          top: top,
          left: left,
          width: width,
          height: height
        }}
        data-cy={'mask'}
      >
        <div
          className='tp-loader'
          role={'alert'}
          // <debug>
          data-cy={'tp-loader-' + maskForModuleId}
          // </debug>
        >
          <div className={maskType ? loaderClass : 'tp-loader-rings'}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div
            className='tp-loader-text'
            data-cy={'mask-message'}
          >
            {message}
          </div>
        </div>
      </div>
    );
  }
}

export default Mask;
